export default __webpack_public_path__ + "static/media/img-guide-gt-popup-4-at_de@3x.54bce59d.png";